<template>
  <p v-if="false" class="text-sm text-gray-400">
    <span class="hidden 3xl:inline">3xl</span>
    <span class="hidden 2xl:inline 3xl:hidden">2xl</span>
    <span class="hidden xl:inline 2xl:hidden">xl</span>
    <span class="hidden lg:inline xl:hidden">lg</span>
    <span class="hidden md:inline lg:hidden">md</span>
    <span class="md:hidden">sm</span>
    {{ viewportWidth }}
  </p>
</template>

<script>
export default {
  data() {
    return {
      viewportWidth: window.innerWidth,
    };
  },

  mounted() {
    window.addEventListener('resize', this.getViewportWidth);
  },

  unmounted() {
    window.removeEventListener('resize', this.getViewportWidth);
  },

  methods: {
    getViewportWidth() {
      this.viewportWidth = window.innerWidth;
    },
  },
};
</script>
